import { Component, AfterViewInit } from '@angular/core';

@Component({
    selector: '[completed-works-list]',
    templateUrl: './completed-works-list.component.html',
    styleUrls: ['./completed-works-list.component.css'],
    standalone: false
})
export class CompletedWorksListComponent implements AfterViewInit {
    ngAfterViewInit() {
        window.dispatchEvent(new CustomEvent("ComponentLoad", { detail: "CompletedWorksList" }));
    }
}
